import { memo } from 'react';
import Link from 'next/link';

import { emojiPageId } from '../../data/pageIds';

import useStyles from './styles';

const all = [
  {
    glyph: '⭐',
    text: 'Star',
    id: emojiPageId.star,
  },
  {
    glyph: '❤️',
    text: 'Red Heart',
    id: emojiPageId.redHeart,
  },
  {
    glyph: '🎄',
    text: 'Christmas Tree',
    id: emojiPageId.christmasTree,
  },
  {
    glyph: '🫠',
    text: 'Melting Face',
    id: emojiPageId.meltingFace,
  },
  {
    glyph: '👀',
    text: 'Eyes',
    id: emojiPageId.eyes,
  },
  {
    glyph: '🤗',
    text: 'Hug',
    id: emojiPageId.huggingFace,
  },
  {
    glyph: '👍',
    text: 'Thumbs Up',
    id: emojiPageId.thumbsUp,
  },
  {
    glyph: '😳',
    text: 'Flushed',
    id: emojiPageId.flushedFace,
  },
  {
    glyph: '🔥',
    text: 'Fire',
    id: emojiPageId.fire,
  },
  {
    glyph: '💤',
    text: 'Sleeping',
    id: emojiPageId.zzz,
  },
];

function OtherEmojis({
  exclude,
  sendEvent,
}: {
  exclude: string;
  sendEvent: (actionType: string) => void;
}) {
  const classes = useStyles();

  return (
    <ul className={classes.otherContainer}>
      {all
        .filter((e) => e.id !== exclude)
        .map(({ glyph, text, id }) => (
          <li key={glyph} onClick={() => sendEvent(`other_emojis_${id?.replaceAll('-', '_')}`)}>
            <Link href={`/${id}`} passHref>
              <a className={classes.otherItem}>
                <span className={classes.otherGlyph}>{glyph}</span>
                <span>{text}</span>
              </a>
            </Link>
          </li>
        ))}
    </ul>
  );
}

export default memo(OtherEmojis);
